import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="flex justify-center items-center py-8">
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin dark:border-gray-600 dark:border-t-gray-300"></div>
        <span className="text-gray-600 dark:text-gray-300 font-medium">Loading repositories...</span>
      </div>
    </div>
  );
};

export default LoadingSpinner;